export default __webpack_public_path__ + "static/Raleway-Italic-VariableFont_wght-87701616ad47257e5b007277d0d4eb6b.ttf";